export default __webpack_public_path__ + "static/manualDevice-f2ceb871102397e1f39016bafde17f19.png";